import { render, staticRenderFns } from "./FilmDetails.vue?vue&type=template&id=6d31119e&scoped=true&"
import script from "./FilmDetails.vue?vue&type=script&lang=ts&"
export * from "./FilmDetails.vue?vue&type=script&lang=ts&"
import style0 from "./FilmDetails.vue?vue&type=style&index=0&id=6d31119e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d31119e",
  null
  
)

export default component.exports